module.exports = __webpack_public_path__ + "static/media/goal-flag.0a7d1dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/goal-flag.png
// module id = 7471
// module chunks = 0